document.addEventListener("DOMContentLoaded", async function () {
  // document.getElementById("product_loader").classList.add("loading");
  const dtf_add_to_cart = document.getElementById("dtf-add-to-cart");

  // **State object to manage selected values**
  const state = {
    fabric: "Light Fabric",
    width: null,
    height: null,
    quantity_variable: 100,
    greater_dimension: null,
    price: 0,
  };

  const sizeBlocks = {
    custom: [], // {width, height, qty, total}
    popular: [], // {sizeStr, width, height, qty, total}
  };

  let originalImageFile = null;
  let bgRemovedImageFile = null;

  const dtfThumbnailHTML = `<div class="dtf-thumbnail" id="dtf-thumbnail">
  <div class="dtf-thumbnail-images" id="cloth-items">
    <div class="dtf-thumbnail-item shirt" id="dtf-shirt">
      <p class="inches">2.5" x 3.5"</p>
      <div class="item-image">
        <img
          src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/shirt.webp"
          alt="shirt"
        />
        <img id="dtf-shirt-blob" class="blob-image" src="" />
      </div>
    </div>

    <div class="dtf-thumbnail-item cap" id="dtf-cap">
      <p class="inches">2.5" x 3.5"</p>
      <div class="item-image">
        <img
          src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/cap.webp"
          alt="cap"
        />
        <img id="dtf-cap-blob" class="blob-image" src="" />
      </div>
    </div>

    <div class="dtf-thumbnail-item t-shirt" id="dtf-t-shirt">
      <p class="inches">2.5" x 3.5"</p>
      <div class="item-image">
        <img
          src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/t-shirt.webp"
          alt="t-shirt"
        />
        <img id="dtf-t-shirt-blob" class="blob-image" src="" />
      </div>
    </div>

    <div class="dtf-thumbnail-item bag" id="dtf-bag">
      <p class="inches">2.5" x 3.5"</p>
      <div class="item-image">
        <img
          src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/bag.webp"
          alt="bag"
        />
        <img id="dtf-bag-blob" class="blob-image" src="" />
      </div>
    </div>

    <div class="dtf-thumbnail-item hoodie" id="dtf-hoodie">
      <p class="inches">2.5" x 3.5"</p>
      <div class="item-image">
        <img
          src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/hoodie.webp"
          alt="hoodie"
        />
        <img id="dtf-hoodie-blob" class="blob-image" src="" />
      </div>
    </div>

    <div class="dtf-thumbnail-item apron" id="dtf-apron">
      <p class="inches">2.5" x 3.5"</p>
      <div class="item-image">
        <img
          src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/apron.webp"
          alt="apron"
        />
        <img id="dtf-apron-blob" class="blob-image" src="" />
      </div>
    </div>
  </div>

  <div class="dtf-color-selector">
    <span class="active" data-color="#f5f5f5"></span>
    <span data-color="black"></span>
    <span data-color="#d8d8d8"></span>
    <span data-color="#ff3900"></span>
    <span data-color="#ffc121"></span>
    <span data-color="#f5e851"></span>
    <span data-color="#82d145"></span>
    <span class="custom-color-trigger" data-color="custom">
      <div class="custom-color-icon"></div>
      <div class="color-picker-container hidden" id="color-picker-container">
        <div id="color-picker"></div>
      </div>
    </span>
  </div>
</div>`;

  // **Function to animate price changes**
  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;

      targetElement.textContent = currentValue.toFixed(2);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function updateFinalAndCutoffPrice() {
    const priceElement = document.querySelector("#pcs-final-price");
    const cutoffPriceElement = document.querySelector("#pcs-cutoff-price");
    const cutoffPriceBlock = document.querySelector(
      ".pcs-price__ticker.cutoff-price"
    );

    let finalTotal = 0;
    let originalTotal = 0;

    // Helper function to get values from elements
    const getPrice = (el) => parseFloat(el.textContent.replace("$", "")) || 0;
    const getOriginal = (el) =>
      parseFloat(el.dataset.originalPrice || el.textContent.replace("$", "")) ||
      0;

    // Calculate totals from all blocks
    document
      .querySelectorAll(
        "#custom-size-list .pcs-size-block .total, #popular-size-list .pcs-size-block .total"
      )
      .forEach((el) => {
        finalTotal += getPrice(el);
        originalTotal += getOriginal(el);
      });

    // Handle cutoff price (original price) with animation
    if (cutoffPriceElement && cutoffPriceBlock) {
      const hasDiscount = originalTotal > finalTotal;

      if (!hasDiscount) {
        cutoffPriceBlock.style.display = "none";
      } else {
        cutoffPriceBlock.style.display = "block";
        animatePriceChange(
          cutoffPriceElement,
          parseFloat(cutoffPriceElement.textContent) || 0,
          originalTotal
        );
      }
    }

    // Update final price with animation
    if (priceElement) {
      animatePriceChange(
        priceElement,
        parseFloat(priceElement.textContent) || 0,
        finalTotal
      );
    }

    // Update calculator hidden field
    const calculator = document.querySelector("#calculator");
    if (calculator) {
      const priceInput = calculator.querySelector(
        "input[name='properties[Price]']"
      );
      if (priceInput) {
        priceInput.value = finalTotal.toFixed(2);
      }
    }
  }

  // **Function to calculate discount based on quantity**
  function calculateDiscount(quantity) {
    if (quantity < 10) {
      return 0;
    } else if (quantity >= 10 && quantity < 50) {
      return 0.2;
    } else if (quantity >= 50 && quantity < 100) {
      return 0.3;
    } else if (quantity >= 100 && quantity < 250) {
      return 0.4;
    } else if (quantity >= 250) {
      return 0.5;
    }
    return 0;
  }

  // **Function to find base price based on area**
  function findBasePrice(area) {
    const styleRanges = [
      { min: 1, max: 9, price: 0.37 },
      { min: 10, max: 19, price: 1.09 },
      { min: 20, max: 29, price: 1.9 },
      { min: 30, max: 39, price: 2.28 },
      { min: 40, max: 49, price: 3.33 },
      { min: 50, max: 59, price: 3.96 },
      { min: 60, max: 69, price: 4.28 },
      { min: 70, max: 79, price: 5.43 },
      { min: 80, max: 89, price: 5.81 },
      { min: 90, max: 99, price: 6.34 },
      { min: 100, max: 109, price: 7.39 },
      { min: 110, max: 119, price: 8.12 },
      { min: 120, max: 129, price: 8.65 },
      { min: 130, max: 139, price: 9.17 },
      { min: 140, max: 149, price: 9.7 },
      { min: 150, max: 159, price: 10.01 },
      { min: 160, max: 169, price: 10.26 },
      { min: 170, max: 179, price: 10.79 },
      { min: 180, max: 189, price: 11.31 },
      { min: 190, max: 199, price: 11.84 },
      { min: 200, max: 209, price: 12.36 },
      { min: 210, max: 219, price: 12.89 },
      { min: 220, max: 229, price: 13.41 },
      { min: 230, max: 239, price: 13.94 },
      { min: 240, max: 249, price: 14.46 },
      { min: 250, max: 259, price: 14.99 },
      { min: 260, max: 269, price: 15.51 },
      { min: 270, max: 279, price: 16.04 },
      { min: 280, max: 309, price: 16.56 },
      { min: 310, max: 349, price: 17.09 },
      { min: 350, max: 389, price: 17.61 },
      { min: 390, max: 429, price: 18.14 },
      { min: 430, max: 469, price: 18.66 },
      { min: 470, max: 509, price: 19.19 },
      { min: 510, max: 549, price: 19.72 },
      { min: 550, max: 589, price: 20.24 },
      { min: 590, max: 629, price: 20.77 },
      { min: 630, max: 669, price: 21.29 },
      { min: 670, max: 709, price: 21.82 },
      { min: 710, max: 749, price: 22.34 },
      { min: 750, max: 789, price: 22.87 },
      { min: 790, max: 829, price: 23.39 },
      { min: 830, max: 869, price: 23.92 },
      { min: 870, max: 909, price: 24.44 },
      { min: 910, max: 949, price: 24.97 },
      { min: 950, max: 989, price: 25.49 },
      { min: 990, max: 1029, price: 26.02 },
      { min: 1030, max: 1069, price: 26.54 },
      { min: 1070, max: 1109, price: 27.07 },
      { min: 1110, max: 1149, price: 27.59 },
      { min: 1150, max: 1189, price: 28.12 },
      { min: 1190, max: 1229, price: 28.64 },
      { min: 1230, max: 1269, price: 29.17 },
      { min: 1270, max: 1309, price: 29.69 },
      { min: 1310, max: 1349, price: 30.22 },
      { min: 1350, max: 1389, price: 30.74 },
      { min: 1390, max: 1429, price: 31.27 },
      { min: 1430, max: 1469, price: 31.79 },
      { min: 1470, max: 1509, price: 32.32 },
      { min: 1510, max: 1549, price: 32.84 },
      { min: 1550, max: 1589, price: 33.37 },
      { min: 1590, max: 1629, price: 33.89 },
      { min: 1630, max: 1669, price: 34.42 },
      { min: 1670, max: 1709, price: 34.94 },
      { min: 1710, max: 1749, price: 35.47 },
      { min: 1750, max: 1789, price: 35.99 },
      { min: 1790, max: 1829, price: 36.52 },
      { min: 1830, max: 1869, price: 37.04 },
      { min: 1870, max: 1909, price: 37.57 },
      { min: 1910, max: 1949, price: 38.09 },
      { min: 1950, max: 1989, price: 38.62 },
      { min: 1990, max: 2029, price: 39.14 },
      { min: 2030, max: 2069, price: 39.67 },
      { min: 2070, max: 2109, price: 40.19 },
      { min: 2110, max: 2149, price: 40.72 },
      { min: 2150, max: 2189, price: 41.24 },
      { min: 2190, max: 2229, price: 41.77 },
      { min: 2230, max: 2269, price: 42.29 },
      { min: 2270, max: 2309, price: 42.82 },
      { min: 2310, max: 2349, price: 43.34 },
      { min: 2350, max: 2389, price: 43.87 },
      { min: 2390, max: 2429, price: 44.39 },
      { min: 2430, max: 2469, price: 44.92 },
      { min: 2470, max: 2509, price: 45.44 },
      { min: 2510, max: 2549, price: 45.97 },
      { min: 2550, max: 2589, price: 46.49 },
      { min: 2590, max: 2629, price: 47.02 },
      { min: 2630, max: 2669, price: 47.54 },
      { min: 2670, max: 2709, price: 48.07 },
      { min: 2710, max: 2749, price: 48.59 },
      { min: 2750, max: 2789, price: 49.12 },
      { min: 2790, max: 2800, price: 49.64 },
    ];

    const flooredArea = Math.floor(area);
    const match = styleRanges.find(
      (r) => flooredArea >= r.min && flooredArea <= r.max
    );
    return match ? match.price : 0;
  }

  // **Main price calculation function**
  function calculatePrice() {
    // Only calculate if we have valid dimensions and quantity
    if (state.width && state.height && state.quantity_variable) {
      const size = state.width * state.height;
      const quantity = state.quantity_variable;

      const basePrice = findBasePrice(size);
      const discount = calculateDiscount(quantity);
      const discountedUnitPrice = basePrice * (1 - discount);
      const finalTotalPrice = discountedUnitPrice * quantity;
      const originalTotalPrice = basePrice * quantity;
      state.price = finalTotalPrice;

      // Update the calculator's price field immediately
      const calculator = document.querySelector("#calculator");
      if (calculator) {
        const priceInput = calculator.querySelector(
          "input[name='properties[Price]']"
        );
        if (priceInput) {
          priceInput.value = finalTotalPrice.toFixed(2);
        }
      }

      // Get the target price elements
      const priceElement = document.querySelector("#pcs-final-price");
      const cutoffPriceElement = document.querySelector("#pcs-cutoff-price");
      const cutoffPriceBlock = document.querySelector(
        ".pcs-price__ticker.cutoff-price"
      );

      if (cutoffPriceElement) {
        if (discount === 0) {
          cutoffPriceBlock.style.display = "none";
        } else {
          cutoffPriceBlock.style.display = "block";
          const currentPrice = parseFloat(cutoffPriceElement.textContent) || 0;
          animatePriceChange(
            cutoffPriceElement,
            currentPrice,
            originalTotalPrice
          );
        }
      }

      if (priceElement) {
        const currentPrice = parseFloat(priceElement.textContent) || 0;
        animatePriceChange(priceElement, currentPrice, finalTotalPrice);
      }

      return finalTotalPrice;
    } else {
      // If we don't have valid dimensions or quantity, show 0.00
      document.querySelector("#pcs-final-price").textContent = "00.00";
      document.querySelector("#pcs-cutoff-price").textContent = "00.00";
      state.price = 0;

      // Update calculator with zero price
      const calculator = document.querySelector("#calculator");
      if (calculator) {
        const priceInput = calculator.querySelector(
          "input[name='properties[Price]']"
        );
        if (priceInput) {
          priceInput.value = "0.00";
        }
      }

      return 0;
    }
  }

  // **Function to safely update calculator values**
  function updateCalculator() {
    const calculator = document.querySelector("#calculator");
    if (!calculator) return;

    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");

    if (fileInput) {
      fileInput.setAttribute(
        "accept",
        ".jpg,.jpeg,.png,.webp,.avif,.tiff,.svg"
      );
    }

    const currentPrice = calculatePrice();

    // Update form values
    if (state.fabric) {
      calculator.querySelector("textarea[name='properties[Fabric]']").value =
        state.fabric;
    }

    if (state.width && state.height) {
      calculator.querySelector("input[name='properties[Width]']").value =
        state.width.toFixed(2);
      calculator.querySelector("input[name='properties[Height]']").value =
        state.height.toFixed(2);
    }

    if (state.quantity_variable) {
      calculator.querySelector("input[name='properties[Quantity]']").value =
        state.quantity_variable;
    }

    const priceInput = calculator.querySelector(
      "input[name='properties[Price]']"
    );
    if (priceInput) {
      priceInput.value = currentPrice.toFixed(2);
    }

    // Calculate and update price
    calculatePrice();
    safePriceUpdation();
  }

  // **Ensures priceUpdation() runs when available**
  function safePriceUpdation() {
    if (typeof window.PriceUpdation === "function") {
      window.PriceUpdation();
    } else {
      console.warn("⚠️ PriceUpdation function not available. Retrying...");
      let retry = setInterval(() => {
        if (typeof window.PriceUpdation === "function") {
          clearInterval(retry);
          console.log("✅ PriceUpdation function found. Executing...");
          window.PriceUpdation();
        }
      }, 500);
    }
  }

  // **Event Listener: Fabric Selection**
  function setupFabricSelection() {
    document.addEventListener("click", function (event) {
      const selectedVariant = event.target.closest(
        "#fabric-variant .sticker-variant"
      );

      if (selectedVariant) {
        document
          .querySelectorAll("#fabric-variant .sticker-variant")
          .forEach((el) => el.classList.remove("active"));

        selectedVariant.classList.add("active");

        const calculator = document.querySelector("#calculator");
        if (calculator) {
          const fabricTextarea = calculator.querySelector(
            "textarea[name='properties[Fabric]']"
          );
          if (fabricTextarea) {
            fabricTextarea.value = selectedVariant.dataset.shape;
          }
        }

        if (state.fabric) {
          state.fabric = selectedVariant.dataset.shape;
        }
      }
    });
  }

  // **Image upload and preview functionality**
  const artbox = document.getElementById("upload-artbox");
  const shortDesc = document.getElementById("short-description");
  const happyCreators = document.getElementById("happy-creators");
  const vulgrCreatorContainer = document.getElementById(
    "vulgrCreatorContainer"
  );
  const previewBox = document.getElementById("preview-box");
  const deleteImage = document.getElementById("delete-image");
  const errorMessage = document.getElementById("upload-file-error");
  const productMedia = document.querySelector(".product .product__media");
  const dtfVariations = document.getElementById("dtf-variations");

  // **Function to convert pixel size to inches**
  function convertToInches(pixels, dpi) {
    return pixels / dpi / 4.167;
  }

  // **Function to get image DPI**
  function getImageDPI(file) {
    return new Promise((resolve) => {
      EXIF.getData(file, function () {
        const xRes = EXIF.getTag(this, "XResolution");
        const yRes = EXIF.getTag(this, "YResolution");
        const resUnit = EXIF.getTag(this, "ResolutionUnit");

        if (xRes && resUnit === 2) {
          resolve(xRes);
        } else {
          resolve(72); // Default DPI
        }
      });
    });
  }

  // **Function to update transfer sizes for different items**
  function updateTransferSizes(originalWidthInches, originalHeightInches) {
    const itemMaxSizes = {
      shirt: { maxWidth: 11, maxHeight: 44.1 },
      cap: { maxWidth: 5, maxHeight: 2.5 },
      "t-shirt": { maxWidth: 3.5, maxHeight: 14.03 },
      bag: { maxWidth: 7, maxHeight: 28.07 },
      hoodie: { maxWidth: 11, maxHeight: 9 },
      apron: { maxWidth: 5, maxHeight: 20.05 },
    };

    Object.entries(itemMaxSizes).forEach(
      ([itemId, { maxWidth, maxHeight }]) => {
        const item = document.querySelector(`#dtf-${itemId}`);
        if (!item) return;

        let finalWidth = originalWidthInches;
        let finalHeight = originalHeightInches;

        const widthRatio = maxWidth / originalWidthInches;
        const heightRatio = maxHeight / originalHeightInches;
        const scale = Math.min(widthRatio, heightRatio);
        finalWidth = originalWidthInches * scale;
        finalHeight = originalHeightInches * scale;

        const sizeLabel = item.querySelector(".inches");
        if (sizeLabel) {
          sizeLabel.textContent = `${finalWidth.toFixed(
            2
          )}" x ${finalHeight.toFixed(2)}"`;
        }
      }
    );
  }

  function resetAllSizeBlocks() {
    sizeBlocks.custom = [];
    sizeBlocks.popular = [];

    document.getElementById("custom-size-list").innerHTML = "";
    document.getElementById("popular-size-list").innerHTML = "";
    document.getElementById("custom-size-list-inside-popular").innerHTML = "";
    document.getElementById("popular-size-list-inside-custom").innerHTML = "";
  }

  // **File input change handler**
  function fileInputChangeHandler(fileInput) {
    const chooseFileBtn = document.getElementById("choose-file-btn");
    const BgToggle = document.getElementById("bg-toggle");

    // Clear any existing click handlers to prevent duplicates
    chooseFileBtn.onclick = null;

    // Set up new click handler
    chooseFileBtn.addEventListener("click", () => {
      fileInput.value = ""; // Reset file input
      fileInput.click();
    });

    fileInput.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      BgToggle.disabled = false;

      // Set up remove background button click handler
      BgToggle.onchange = async (e) => {
        const errorMsg = document.getElementById("errorMsg");
        if (bgRemovedImageFile == null && e.target.checked === true) {
          errorMsg.style.display = "none";
          errorMsg.textContent = "";
          const success = await removeBackground(file);
          if (success) {
            fileInput.value = "";
            fileInput.click();
          }
        }
      };

      const img = document.querySelector("#preview-image");
      const reader = new FileReader();

      if (!fileInput.files.length && !emailLaterCheckbox.checked) {
        dtf_add_to_cart.disabled = true;
      } else {
        dtf_add_to_cart.disabled = false;
        setTimeout((e) => {
          dtf_add_to_cart.classList.add("shine");
        }, 1000);
        setTimeout((e) => {
          dtf_add_to_cart.classList.remove("shine");
        }, 2000);
      }

      reader.onload = async (e) => {
        const tempImg = new Image();
        tempImg.src = e.target.result;

        tempImg.onload = async () => {
          const width = tempImg.naturalWidth;
          const height = tempImg.naturalHeight;

          const MAX_PIXELS = 30000;
          if (width > MAX_PIXELS || height > MAX_PIXELS) {
            errorMessage.classList.add("active");
            errorMessage.textContent = `Image dimensions are too large (${width}x${height}). Please upload a smaller image.`;
            fileInput.value = "";
            return;
          }

          img.src = e.target.result;

          img.onload = async () => {
            try {
              const dpi = await getImageDPI(file);
              let originalWidthInches = convertToInches(width, dpi);
              let originalHeightInches = convertToInches(height, dpi);

              // Validate dimensions against min/max
              const MIN_WIDTH_IN = 1;
              const MAX_WIDTH_IN = 28;
              const MIN_HEIGHT_IN = 1;
              const MAX_HEIGHT_IN = 100;

              // Ensure minimum size
              if (
                originalWidthInches < MIN_WIDTH_IN ||
                originalHeightInches < MIN_HEIGHT_IN
              ) {
                const scaleFactor = Math.max(
                  MIN_WIDTH_IN / originalWidthInches,
                  MIN_HEIGHT_IN / originalHeightInches
                );
                originalWidthInches = originalWidthInches * scaleFactor;
                originalHeightInches = originalHeightInches * scaleFactor;
              }

              // Ensure maximum size
              if (
                originalWidthInches > MAX_WIDTH_IN ||
                originalHeightInches > MAX_HEIGHT_IN
              ) {
                const scaleFactor = Math.min(
                  MAX_WIDTH_IN / originalWidthInches,
                  MAX_HEIGHT_IN / originalHeightInches
                );
                originalWidthInches = originalWidthInches * scaleFactor;
                originalHeightInches = originalHeightInches * scaleFactor;
              }

              // Display dimensions (rounded to 2 decimal places)
              const displayWidth = originalWidthInches.toFixed(2);
              const displayHeight = originalHeightInches.toFixed(2);

              // Update UI with dimensions
              document.getElementById(
                "width-inch"
              ).textContent = `${displayWidth}"`;
              document.getElementById(
                "height-inch"
              ).textContent = `${displayHeight}"`;

              // Show preview and hide upload area
              artbox.style.display = "none";
              shortDesc.style.display = "none";
              happyCreators.style.display = "none";
              vulgrCreatorContainer.style.display = "none";
              previewBox.style.display = "block";
              productMedia.classList.add("hidden");
              dtfVariations.classList.remove("hidden");

              // Initialize or update thumbnail preview
              let dtfThumbnail = document.getElementById("dtf-thumbnail");
              if (!dtfThumbnail) {
                productMedia.insertAdjacentHTML("beforeend", dtfThumbnailHTML);
                dtfThumbnail = document.getElementById("dtf-thumbnail");
                colorInject();
              } else {
                dtfThumbnail.classList.remove("hidden");
              }

              // Update state with validated dimensions
              state.width = parseFloat(displayWidth);
              state.height = parseFloat(displayHeight);
              state.quantity_variable = 100;

              toggleTabsPills(true); // Show Custom Size Tab
              const customContainer =
                document.getElementById("custom-size-list");
              resetAllSizeBlocks();

              // Add one block with uploaded size
              addCustomSizeBlock();

              setTimeout(() => {
                const lastBlock = customContainer.querySelector(
                  ".pcs-size-block:last-child"
                );
                const widthInput = lastBlock.querySelector(".width");
                const heightInput = lastBlock.querySelector(".height");
                const qtyInput = lastBlock.querySelector(".qty");

                widthInput.value = state.width.toFixed(2);
                heightInput.value = state.height.toFixed(2);
                heightInput.disabled = false; // Re-enable to reflect value
                qtyInput.value = state.quantity_variable;

                // Trigger update manually
                widthInput.dispatchEvent(new Event("input"));
              }, 100);

              updateTransferSizes(state.width, state.height);
              updateCalculator();

              // Update blob images with the uploaded image
              const blobImages = document.querySelectorAll(
                "#dtf-thumbnail .blob-image"
              );
              if (blobImages.length > 0) {
                blobImages.forEach((img) => {
                  img.src = e.target.result;
                });
              } else {
                // If blob images don't exist, recreate them
                const newBlobImages =
                  dtfThumbnail.querySelectorAll(".blob-image");
                newBlobImages.forEach((img) => {
                  img.src = e.target.result;
                });
              }

              // Update calculator with image data
              const calculator = document.querySelector("#calculator");
              if (calculator) {
                const formFileInput = calculator.querySelector(
                  "input[name='properties[Upload Image]']"
                );
                if (formFileInput) {
                  const dataTransfer = new DataTransfer();
                  dataTransfer.items.add(file);
                  formFileInput.files = dataTransfer.files;
                }
              }
            } catch (error) {
              console.error("Error processing image:", error);
              errorMessage.classList.add("active");
              errorMessage.textContent =
                "An error occurred while processing the image.";
              fileInput.value = "";
            }
          };
        };

        tempImg.onerror = () => {
          errorMessage.classList.add("active");
          errorMessage.textContent =
            "Failed to load image. It might be corrupted.";
          fileInput.value = "";
        };
      };

      reader.onerror = () => {
        errorMessage.classList.add("active");
        errorMessage.textContent = "Failed to read file.";
        fileInput.value = "";
      };

      reader.readAsDataURL(file);
    };
  }

  document.getElementById("bg-toggle").addEventListener("change", function () {
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    const useBgRemoved = this.checked;
    const dataTransfer = new DataTransfer();
    if (useBgRemoved && bgRemovedImageFile) {
      dataTransfer.items.add(bgRemovedImageFile);
    } else if (originalImageFile) {
      dataTransfer.items.add(originalImageFile);
    }
    fileInput.files = dataTransfer.files;
    fileInput.dispatchEvent(new Event("change"));
  });

  // Helper function to reset file input
  function resetFileInput(fileInput) {
    fileInput.value = "";
    // For IE compatibility
    if (fileInput.value) {
      fileInput.type = "text";
      fileInput.type = "file";
    }
  }
  // **Delete image handler**
  deleteImage.addEventListener("click", (e) => {
    const dtfThumbnail = document.getElementById("dtf-thumbnail");
    artbox.style.display = "block";
    shortDesc.style.display = "flex";
    happyCreators.style.display = "block";
    vulgrCreatorContainer.style.display = "flex";
    previewBox.style.display = "none";
    productMedia.classList.remove("hidden");
    dtfVariations.classList.add("hidden");
    if (dtfThumbnail) dtfThumbnail.classList.add("hidden");

    const calcImage = document.querySelector(
      "#calculator input[name='properties[Upload Image]']"
    );
    if (calcImage) calcImage.value = null;

    // Reset state
    state.width = null;
    state.height = null;

    // Reset sizeBlocks data
    sizeBlocks.custom = [];
    sizeBlocks.popular = [];

    // Clear related DOM containers
    document.getElementById("custom-size-list").innerHTML = "";
    document.getElementById("popular-size-list").innerHTML = "";
    document.getElementById("custom-size-list-inside-popular").innerHTML = "";
    document.getElementById("popular-size-list-inside-custom").innerHTML = "";

    originalImageFile = null;
    bgRemovedImageFile = null;
    document.getElementById("bg-toggle").checked = false;

    updateCalculator();
  });

  function colorInject() {
    const colorBoxes = document.querySelectorAll(
      ".dtf-color-selector span:not(.custom-color-trigger)"
    );
    const clothItems = document.getElementById("cloth-items");
    const customColorTrigger = document.querySelector(".custom-color-trigger");
    const colorPickerContainer = document.getElementById(
      "color-picker-container"
    );

    // Initialize color picker (hidden by default)
    const colorPicker = new iro.ColorPicker("#color-picker", {
      width: 180,
      color: "#ffffff",
      layoutDirection: "horizontal",
      display: "flex",
      layout: [
        { component: iro.ui.Box },
        {
          component: iro.ui.Slider,
          options: { sliderType: "hue" },
        },
      ],
    });

    // Set background colors for swatches
    colorBoxes.forEach((box) => {
      box.style.backgroundColor = box.getAttribute("data-color");

      box.addEventListener("click", function () {
        // Remove active from all
        document
          .querySelectorAll(".dtf-color-selector span")
          .forEach((item) => {
            item.classList.remove("active");
          });

        // Add to clicked
        this.classList.add("active");
        clothItems.style.background = this.getAttribute("data-color");
        clothItems.querySelectorAll(".dtf-thumbnail-item").forEach((e) => {
          e.style.background = this.getAttribute("data-color");
        });
        colorPickerContainer.classList.add("hidden");
      });
    });

    // Custom color trigger click handler
    customColorTrigger.addEventListener("click", function (e) {
      e.stopPropagation();

      // Remove active from all swatches
      colorBoxes.forEach((item) => item.classList.remove("active"));
      this.classList.add("active");

      // Show color picker
      colorPickerContainer.classList.remove("hidden");

      // Apply the current color from picker INSTANTLY
      clothItems.style.background = colorPicker.color.hexString;
      clothItems.querySelectorAll(".dtf-thumbnail-item").forEach((e) => {
        e.style.background = colorPicker.color.hexString;
      });
      this.dataset.selectedColor = colorPicker.color.hexString;
      this.dataset.color = colorPicker.color.hexString;
    });

    // Real-time color changes
    colorPicker.on("color:change", function (color) {
      // Apply color immediately
      clothItems.style.background = color.hexString;
      clothItems.querySelectorAll(".dtf-thumbnail-item").forEach((e) => {
        e.style.background = color.hexString;
      });
      // Update custom swatch preview
      customColorTrigger.style.backgroundColor = color.hexString;
      // Store the selected color
      customColorTrigger.dataset.selectedColor = color.hexString;
      customColorTrigger.dataset.color = color.hexString;
    });

    // Close picker when clicking outside
    document.addEventListener("click", function (e) {
      if (
        !colorPickerContainer.contains(e.target) &&
        e.target !== customColorTrigger
      ) {
        colorPickerContainer.classList.add("hidden");
      }
    });
  }

  function addToCartEvent() {
    dtf_add_to_cart.addEventListener("click", async (e) => {
      e.preventDefault();
      dtf_add_to_cart.disabled = true;
      dtf_add_to_cart.classList.add("loading");
      dtf_add_to_cart.innerHTML = `Adding to Cart <div class="dot-falling"></div>`;

      const calculatorId = "79506c6905604";
      const productId = 7661297827888;
      const fabric = state.fabric;
      const file = document.querySelector(".calc-prop.cpc-file-upload")?.files?.[0];

      if (!file) {
        alert("No image file selected!");
        return;
      }

      const allBlocks = [...sizeBlocks.custom, ...sizeBlocks.popular];
      const variants = [];
      const cartItems = []; // To store cart items for verification

      try {
        for (const block of allBlocks) {
          const props = {
            Fabric: fabric,
            Width: block.width.toFixed(2),
            Height: block.height.toFixed(2),
            Quantity: block.qty.toString(),
            Price: block.total.toFixed(2),
            "Upload Image": file.name, // for Apippa metadata (not used in add.js)
          };

          const payload = {
            calculatorId,
            productId,
            properties: props,
          };

          const res = await fetch(
            "https://api.custompricecalculator.com/api/v1/variant",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(payload),
            }
          );

          const json = await res.json();
          const variantId =
            typeof json === "string" ? json : json?.variantId || json?.id;

          if (!variantId) throw new Error("Invalid variantId received");
          variants.push({ id: variantId, props: props });
        }

        // Now add each variant to the cart
        for (const variant of variants) {
          const formData = new FormData();
          formData.append("id", variant.id);
          formData.append("quantity", 1);

          Object.entries(variant.props).forEach(([key, value]) => {
            formData.append(`properties[${key}]`, value);
          });

          if (file) {
            formData.append("properties[Upload Image]", file);
          }

          const cartAddRes = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          });

          const cartAddJson = await cartAddRes.json();
          cartItems.push(cartAddJson); // Store cart items for verification
        }

        // Wait for Shopify cart to settle
        await new Promise((r) => setTimeout(r, 300));

        // Open mini-cart
        const timestamp = Date.now();
        const html = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((r) => r.text());

        const fake = document.createElement("div");
        fake.innerHTML = html;
        const miniCartHTML = fake.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");

        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: { sections: { "mini-cart": miniCartHTML } },
                openMiniCart: true,
              },
            })
          );
        }

        // Additional verification after cart opens
        setTimeout(() => {
          if (!cartDrawer) return;

          const lineItems = cartDrawer.querySelectorAll("line-item");

          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price"
            );

            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
            );

            if (!desktopPriceContainer && !mobilePriceContainer) return;

            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|\$0\.00/.test(priceText);

            let variantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              variantId = productLink.href.split("variant=")[1].split("&")[0];
            }

            if (!variantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']"
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              variantId = match?.[1];
            }

            if (isFree && variantId) {
              // Find matching item in our cartItems array
              const matchingItem = cartItems.find(
                (item) => String(item.id) === variantId
              );

              if (matchingItem) {
                const correctPrice = (matchingItem.price / 100).toFixed(2);

                const imageWrapper = lineItem.querySelector(
                  ".line-item__image-wrapper"
                );
                const productThumbnail = imageWrapper.querySelector(
                  "img.line-item__image"
                );
                const productTitle = lineItem.querySelector(
                  ".product-item-meta .product-item-meta__title"
                );

                if (!productThumbnail) {
                  const imgSrc = document.querySelector(
                    ".product__thumbnail-item .product__thumbnail img"
                  )?.src;
                  if (imgSrc) {
                    imageWrapper.innerHTML += `
                      <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                    `;
                  }
                }

                if (productTitle && productTitle.textContent.trim() === "") {
                  const metaTitle = document.querySelector(
                    ".product__info .product-meta__title"
                  );
                  if (metaTitle) {
                    productTitle.textContent = metaTitle.textContent;
                  }
                }

                // Update both prices
                const updatedPriceHTML = `
                  <span class="visually-hidden">Sale price</span>
                  $${correctPrice}
                `;
                if (desktopPriceContainer) {
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                }
                if (mobilePriceContainer) {
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
                }
              }
            }
          });
        }, 500); // Slightly longer delay for multiple items

        // Update cart count
        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);
      } catch (err) {
        console.error("🚨 Error during cart add:", err);
        alert("Something went wrong while adding items to the cart.");
      } finally {
        dtf_add_to_cart.disabled = false;
        dtf_add_to_cart.classList.remove("loading");
        dtf_add_to_cart.innerHTML = "Add to Cart";
      }
    });
  }

  function toggleTabsPills(showCustom) {
    const customSizeTab = document.getElementById("custom-size-tab");
    const customSizePill = document.getElementById("custom-size-pill");
    const popularSizeTab = document.getElementById("popular-size-tab");
    const popularSizePill = document.getElementById("popular-size-pill");

    if (showCustom) {
      customSizeTab.classList.add("active");
      customSizePill.classList.add("active");
      popularSizeTab.classList.remove("active");
      popularSizePill.classList.remove("active");
    } else {
      customSizeTab.classList.remove("active");
      customSizePill.classList.remove("active");
      popularSizeTab.classList.add("active");
      popularSizePill.classList.add("active");

      if (sizeBlocks.popular.length < 1) {
        addPopularSizeBlock();
      }
    }
  }

  function calculateRowPrice(width, height, qty) {
    const area = width * height;
    const basePrice = findBasePrice(area);
    const discount = calculateDiscount(qty);
    const unitPrice = basePrice * (1 - discount);
    return {
      unitPrice,
      total: unitPrice * qty,
      originalTotal: basePrice * qty, // Add this line
    };
  }

  function refreshRemoveButtons(type) {
    const blockList = document.querySelectorAll(
      type === "custom"
        ? "#custom-size-list .pcs-size-block"
        : "#popular-size-list .pcs-size-block"
    );

    // Only hide remove button for single block if type is "custom"
    const shouldShow = type !== "custom" || blockList.length > 1;

    blockList.forEach((block) => {
      const btn = block.querySelector(".remove");
      if (btn) {
        btn.style.display = shouldShow ? "flex" : "none";
      }
    });

    // Also mirror list
    const mirrorList = document.querySelectorAll(
      type === "custom"
        ? "#custom-size-list-inside-popular .pcs-size-block"
        : "#popular-size-list-inside-custom .pcs-size-block"
    );

    mirrorList.forEach((block) => {
      const btn = block.querySelector(".remove");
      if (btn) {
        btn.style.display = shouldShow ? "flex" : "none";
      }
    });
  }

    function blinkNewBlock(block) {
    const elements = block.querySelectorAll(
      ".select-dropdown, .input-field"
    );

    elements.forEach((el) => {
      el.classList.remove("blink-highlight"); // reset if reused
      void el.offsetWidth; // force reflow
      el.classList.add("blink-highlight");
    });
  }

  function scrollBlockIntoView(block) {
    if (window.innerWidth > 768) return;

    requestAnimationFrame(() => {
      block.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    });
  }

  function scrollAfterRemoval(block) {
    if (window.innerWidth > 768) return;

    const target =
      block.previousElementSibling ||
      block.nextElementSibling ||
      null;

    if (!target) return;

    // Wait until DOM updates
    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    });
  }

  function addCustomSizeBlock() {
    const width = state.width || 1;
    const height = state.height || 1;
    const qty = state.quantity_variable || 1;
    const { unitPrice, total, originalTotal } = calculateRowPrice(
      width,
      height,
      qty
    );
    const discountPercent = calculateDiscount(qty) * 100;

    const data = { width, height, qty, total };
    const blockIndex = sizeBlocks.custom.length;
    sizeBlocks.custom.push(data);

    const block = document.createElement("div");
    block.classList.add("pcs-size-block");

    block.innerHTML = `
    <div class="row">
      <div class="fields">
        <div class="block-item width-item" head="Width (In)"><input type="number" class="width input-field" step="0.01" min="1" max="28" /></div>
        <div class="block-item height-item" head="Height (In)"><input type="number" class="height input-field" step="0.01" min="1" max="100" /></div>
      </div>
      <div class="block-item price-item" head="Price"><span class="price">$${unitPrice.toFixed(
        2
      )}</span></div>
      <div class="block-item qty-item" head="Quantity"><input type="number" class="qty input-field" min="1" value="${qty}" /></div>
      <div class="block-item total-item" head="Total"><span class="total" data-discount="${discountPercent}% off" data-original-price="${originalTotal.toFixed(
      2
    )}">$${total.toFixed(2)}</span></div>
      <button class="remove"><img src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/remove.png" /></button>
    </div>`;

    const widthInput = block.querySelector(".width");
    const heightInput = block.querySelector(".height");
    widthInput.value = width.toFixed(2);
    heightInput.value = height.toFixed(2);

    const container = document.getElementById("custom-size-list");
    container.appendChild(block);

    if (sizeBlocks.custom.length == 1) {
      blinkNewBlock(block);
    }

    scrollBlockIntoView(block);

    // Create mirror in Popular tab
    const clone = block.cloneNode(true);
    clone.classList.add("mirror-block");
    clone
      .querySelectorAll("input, select, button")
      .forEach((el) => (el.disabled = true));
    document
      .getElementById("custom-size-list-inside-popular")
      .appendChild(clone);

    // Link both elements for sync/removal
    block.mirror = clone;
    clone.mirror = block;

    setupCustomSizeBlockListeners(block, blockIndex);

    // Enable remove both
    [block, clone].forEach((el) => {
      el.querySelector(".remove").addEventListener("click", () => {
        scrollAfterRemoval(block);

        sizeBlocks.custom.splice(blockIndex, 1);
        block.remove();
        clone?.remove();

        refreshRemoveButtons("custom");
        updateFinalAndCutoffPrice();
      });
    });

    refreshRemoveButtons("custom");
    updateFinalAndCutoffPrice();
  }

  function addPopularSizeBlock() {
    const width = 2;
    const height = 2;
    const qty = 100;
    const { unitPrice, total, originalTotal } = calculateRowPrice(
      width,
      height,
      qty
    );
    const discountPercent = calculateDiscount(qty) * 100;

    const data = { width, height, qty, total };
    const blockIndex = sizeBlocks.popular.length;
    sizeBlocks.popular.push(data);

    const block = document.createElement("div");
    block.classList.add("pcs-size-block");

    block.innerHTML = `
    <div class="row">
      <div class="block-item select-item" head="Size">
        <select class="preset select-dropdown">
          <option value="2x2" data-width="2" data-height="2" selected>2" x 2"</option>
          <option value="3x3" data-width="3" data-height="3">3" x 3"</option>
          <option value="4x2" data-width="4" data-height="2">4" x 2"</option>
          <option value="4x4" data-width="4" data-height="4">4" x 4"</option>
          <option value="6x6" data-width="6" data-height="6">6" x 6"</option>
          <option value="8x8" data-width="8" data-height="8">8" x 8"</option>
        </select>
      </div>
      <div class="block-item price-item" head="Price"><span class="price">$${unitPrice.toFixed(
        2
      )}</span></div>
      <div class="block-item qty-item" head="Quantity"><input type="number" class="qty input-field" min="1" value="${qty}" /></div>
      <div class="block-item total-item" head="Total"><span class="total" data-discount="${discountPercent}% off" data-original-price="${originalTotal.toFixed(
      2
    )}">$${total.toFixed(2)}</span></div>
      <button class="remove"><img src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/remove.png" /></button>
    </div>`;

    const container = document.getElementById("popular-size-list");
    container.appendChild(block);

    scrollBlockIntoView(block);

    if (sizeBlocks.popular.length == 1) {
      blinkNewBlock(block);
    }

    const clone = block.cloneNode(true);
    clone.classList.add("mirror-block");
    clone
      .querySelectorAll("input, select, button")
      .forEach((el) => (el.disabled = true));
    document
      .getElementById("popular-size-list-inside-custom")
      .appendChild(clone);

    block.mirror = clone;
    clone.mirror = block;

    setupPopularSizeBlockListeners(block, blockIndex);

    [block, clone].forEach((el) => {
      el.querySelector(".remove").addEventListener("click", () => {
        scrollAfterRemoval(block);

        sizeBlocks.popular.splice(blockIndex, 1);
        block.remove();
        clone?.remove();

        refreshRemoveButtons("popular");
        updateFinalAndCutoffPrice();
      });
    });
    refreshRemoveButtons("popular");
    updateFinalAndCutoffPrice();
  }

  function setupCustomSizeBlockListeners(block, index) {
    const widthInput = block.querySelector(".width");
    const heightInput = block.querySelector(".height");
    const qtyInput = block.querySelector(".qty");
    const priceEl = block.querySelector(".price");
    const totalEl = block.querySelector(".total");
    // const discountEl = block.querySelector(".discount");
    const removeBtn = block.querySelector(".remove");

    const mirror = block.mirror;

    let aspectRatio = state.width / state.height || 1;

    const update = () => {
      const width = parseFloat(widthInput.value);
      const height = parseFloat(heightInput.value);
      const qty = parseInt(qtyInput.value);
      if (isNaN(width) || isNaN(height) || isNaN(qty)) return;

      const discount = calculateDiscount(qty);
      const { unitPrice, total, originalTotal } = calculateRowPrice(
        width,
        height,
        qty
      );

      priceEl.textContent = `$${unitPrice.toFixed(2)}`;
      totalEl.textContent = `$${total.toFixed(2)}`;
      totalEl.dataset.originalPrice = originalTotal.toFixed(2);
      totalEl.dataset.discount = `${(discount * 100).toFixed(0)}% off`;

      sizeBlocks.custom[index] = { width, height, qty, total };

      // ✅ Sync values into visible DOM clone
      if (mirror) {
        mirror.querySelector(".width").value = width.toFixed(2);
        mirror.querySelector(".height").value = height.toFixed(2);
        mirror.querySelector(".qty").value = qty;
        mirror.querySelector(".price").textContent = `$${unitPrice.toFixed(2)}`;
        mirror.querySelector(".total").textContent = `$${total.toFixed(2)}`;
        mirror.querySelector(".total").dataset.discount = `${(
          discount * 100
        ).toFixed(0)}% off`;
      }

      updateFinalAndCutoffPrice();
    };

    widthInput.addEventListener("input", (e) => {
      let width = parseFloat(widthInput.value);
      if (isNaN(width) || width < 1) return;
      if (e.target.value > 28) e.target.value = 28;
      let height = width / aspectRatio;
      if (height > 100) {
        height = 100;
        width = height * aspectRatio;
      }
      heightInput.value = height.toFixed(2);
      update();
    });

    heightInput.addEventListener("input", (e) => {
      let height = parseFloat(heightInput.value);
      if (isNaN(height) || height < 1) return;
      if (e.target.value > 100) e.target.value = 100;
      let width = height * aspectRatio;
      if (width > 28) {
        width = 28;
        height = width / aspectRatio;
      }
      widthInput.value = width.toFixed(2);
      update();
    });

    qtyInput.addEventListener("input", update);

    update(); // Initial sync
  }

  function setupPopularSizeBlockListeners(block, index) {
    const preset = block.querySelector(".preset");
    const qtyInput = block.querySelector(".qty");
    const priceEl = block.querySelector(".price");
    const totalEl = block.querySelector(".total");
    // const discountEl = block.querySelector(".discount");
    const removeBtn = block.querySelector(".remove");

    const mirror = block.mirror;

    function updatePopular() {
      const selected = preset.options[preset.selectedIndex];
      const width = parseFloat(selected.dataset.width);
      const height = parseFloat(selected.dataset.height);
      const qty = parseInt(qtyInput.value);

      if (isNaN(width) || isNaN(height) || isNaN(qty)) return;

      const discount = calculateDiscount(qty);
      const { unitPrice, total, originalTotal } = calculateRowPrice(
        width,
        height,
        qty
      );

      priceEl.textContent = `$${unitPrice.toFixed(2)}`;
      totalEl.textContent = `$${total.toFixed(2)}`;
      totalEl.dataset.originalPrice = originalTotal.toFixed(2);
      totalEl.dataset.discount = `${(discount * 100).toFixed(0)}% off`;

      sizeBlocks.popular[index] = { width, height, qty, total };

      // ✅ Sync mirror
      if (mirror) {
        const mirrorPreset = mirror.querySelector(".preset");
        const mirrorQty = mirror.querySelector(".qty");
        const mirrorPrice = mirror.querySelector(".price");
        const mirrorTotal = mirror.querySelector(".total");
        // const mirrorDiscount = mirror.querySelector(".discount");

        if (mirrorPreset) {
          [...mirrorPreset.options].forEach((opt) => {
            if (
              parseFloat(opt.dataset.width) === width &&
              parseFloat(opt.dataset.height) === height
            ) {
              opt.selected = true;
            } else {
              opt.selected = false;
            }
          });
        }

        if (mirrorQty) mirrorQty.value = qty;
        if (mirrorPrice) mirrorPrice.textContent = `$${unitPrice.toFixed(2)}`;
        if (mirrorTotal) mirrorTotal.textContent = `$${total.toFixed(2)}`;
        if (mirrorTotal)
          mirrorTotal.dataset.discount = `${(discount * 100).toFixed(0)}% off`;
      }

      updateFinalAndCutoffPrice();
    }

    if (preset) preset.addEventListener("change", updatePopular);
    if (qtyInput) qtyInput.addEventListener("input", updatePopular);

    updatePopular(); // Initial sync
  }

  function initializeSizeTabBlocks() {
    document
      .getElementById("add-custom-size")
      .addEventListener("click", addCustomSizeBlock);
    document
      .getElementById("add-popular-size")
      .addEventListener("click", addPopularSizeBlock);
    document
      .getElementById("custom-size-tab")
      .addEventListener("click", () => toggleTabsPills(true));
    document
      .getElementById("popular-size-tab")
      .addEventListener("click", () => toggleTabsPills(false));
  }

  async function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function checkSession() {
    try {
      const res = await fetch("https://ai.vulgrco.com/check_session", {
        method: "GET",
        credentials: "include",
      });
      return res.ok;
    } catch {
      return false;
    }
  }

  async function getSession() {
    await fetch("https://ai.vulgrco.com/get_session", {
      method: "GET",
      credentials: "include",
    });
  }

  async function getFingerprint() {
    // Canvas fingerprint
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.textBaseline = "top";
    ctx.font = "16px Arial";
    ctx.fillText(":unicorn_face: Vulgrco Fingerprint!", 2, 2);
    const canvasData = canvas.toDataURL();

    // Audio fingerprint
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const analyser = audioCtx.createAnalyser();
    const gain = audioCtx.createGain();
    const script = audioCtx.createScriptProcessor(256, 1, 1);
    oscillator.type = "triangle";
    oscillator.frequency.value = 10000;
    gain.gain.value = 0;
    oscillator.connect(gain);
    gain.connect(analyser);
    analyser.connect(script);
    script.connect(audioCtx.destination);
    oscillator.start(0);

    const audioFingerprint = await new Promise((resolve) => {
      script.onaudioprocess = function () {
        const freqData = new Float32Array(analyser.frequencyBinCount);
        analyser.getFloatFrequencyData(freqData);
        resolve(freqData.slice(0, 10).join(","));
        oscillator.stop();
        script.disconnect();
      };
    });

    const raw = [
      navigator.platform,
      screen.width,
      screen.height,
      navigator.hardwareConcurrency,
      navigator.deviceMemory || 0,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      canvasData,
      audioFingerprint,
    ].join("|");

    const data = new TextEncoder().encode(raw);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }

  async function removeBackground(file) {
    const bgToggle = document.getElementById("bg-toggle");
    const errorMsg = document.getElementById("errorMsg");
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    const bgRemoverLoader = document.getElementById("bg-remover-loader");

    let hadError = false;

    try {
      // UI: start loading
      bgToggle.disabled = true;
      bgRemoverLoader.classList.add("active");
      errorMsg.style.display = "none";

      // Prepare request
      const base64 = await fileToBase64(file);
      const fingerprint = await getFingerprint();

      const res = await fetch("https://ai.vulgrco.com/bg_remove", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "kaka",
          "X-FINGERPRINT": fingerprint,
        },
        credentials: "include",
        body: JSON.stringify({ image: base64 }),
      });

      // Validate response
      const contentType = res.headers.get("content-type");
      const isJSON = contentType && contentType.includes("application/json");
      const data = isJSON ? await res.json() : null;

      if (!res.ok) {
        hadError = true;
        throw new Error(
          data?.error || `Server error: ${res.status} ${res.statusText}`
        );
      }

      if (!data?.job_id) {
        hadError = true;
        throw new Error("Invalid response from background remover.");
      }

      // Wait for job to complete
      const result = await waitForJob(data.job_id);
      if (!result?.download_url) {
        hadError = true;
        throw new Error("Failed to get background-removed image.");
      }

      // Replace file input
      originalImageFile = file;
      bgRemovedImageFile = await urlToFile(
        result.download_url,
        `bg-removed-${file.name}`,
        file.type
      );

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(bgRemovedImageFile);
      fileInput.files = dataTransfer.files;
      fileInput.dispatchEvent(new Event("change"));

      return true;
    } catch (err) {
      hadError = true;
      console.error("BG Removal Error:", err);

      let cleanMsg = err.message;
      if (cleanMsg.includes("<") || cleanMsg.length > 80) {
        cleanMsg = "Server error or invalid response.";
      }

      errorMsg.style.display = "block";
      errorMsg.textContent =
        "❌ Oops! Our AI tripped over a pixel — Try again.";
      bgToggle.checked = false;
      return false;
    } finally {
      bgToggle.disabled = false;
      bgRemoverLoader.classList.remove("active");
      if (!hadError) errorMsg.style.display = "none";
    }
  }

  async function waitForJob(jobId) {
    const errorMsg = document.getElementById("errorMsg");

    const poll = async () => {
      try {
        const res = await fetch(`https://ai.vulgrco.com/status/${jobId}`, {
          headers: { "X-API-KEY": "kaka" },
          credentials: "include",
        });

        if (!res.ok) {
          throw new Error("Failed to get status");
        }

        const data = await res.json();
        if (data.status === "failed") {
          throw new Error("Background removal failed");
        }

        if (data.status === "finished") {
          return data.result; // Return the entire result object
        }

        await new Promise((resolve) => setTimeout(resolve, 1000));
        return poll();
      } catch (err) {
        errorMsg.style.display = "block";
        errorMsg.innerHTML = `<p>❌ ${err.message}</p>`;
        throw err;
      }
    };

    return poll();
  }

  // Helper function to convert a URL to a File object
  async function urlToFile(url, filename, mimeType) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: mimeType });
  }

  // AI Image Generation
  const vulgrOpenButton = document.getElementById("vulgrOpenButton");
  const vulgrModalWindow = document.getElementById("vulgrModalWindow");
  const vulgrGenerateButton = document.getElementById("vulgrGenerateButton");
  const vulgrPromptInput = document.getElementById("vulgrPromptInput");
  const vulgrStatusMessage = document.getElementById("vulgrStatusMessage");
  const vulgrModalCloseButton = document.getElementById(
    "vulgrModalCloseButton"
  );
  const vulgrResultsContainer = document.querySelector(
    ".vulgr-results-container"
  );
  const loadingLotties = `<div class="lottie-wrapper">
          <dotlottie-player src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/generating-images.lottie"
            background="transparent" speed="1" loop="" autoplay=""></dotlottie-player>
        </div>
        <div class="lottie-wrapper">
          <dotlottie-player src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/generating-images.lottie"
            background="transparent" speed="1" loop="" autoplay=""></dotlottie-player>
        </div>
        <div class="lottie-wrapper">
          <dotlottie-player src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/generating-images.lottie"
            background="transparent" speed="1" loop="" autoplay=""></dotlottie-player>
        </div>`;

  function closeVulgrModal() {
    vulgrModalWindow.style.display = "none";

    // Reset prompt input
    vulgrPromptInput.value = "";

    // Remove generated images
    vulgrResultsContainer.querySelectorAll("img").forEach((el) => el.remove());
    vulgrResultsContainer.innerHTML = loadingLotties;
    vulgrResultsContainer.style.display = "none";

    // Reset example and status
    document.querySelector(".vulgr-prompt-example").style.display = "block";
    document.querySelector(".vulgr-output-example").style.display = "block";
    vulgrStatusMessage.textContent = "";
    vulgrStatusMessage.style.display = "none";
  }

  vulgrOpenButton.onclick = () => (vulgrModalWindow.style.display = "flex");
  vulgrModalCloseButton.onclick = () => closeVulgrModal();

  async function checkJobStatus(jobId) {
    const res = await fetch(`https://ai.vulgrco.com/status/${jobId}`, {
      method: "GET",
      headers: { "X-API-KEY": "kaka" },
      credentials: "include",
    });
    if (!res.ok) return null;
    return await res.json();
  }

  async function waitForImageJob(jobId) {
    vulgrStatusMessage.style.display = "block";
    vulgrModalCloseButton.disabled = true;

    const displayed = new Set(); // track rendered images
    const dotlottieElements = document.querySelectorAll(
      ".vulgr-results-container .lottie-wrapper"
    );

    const poll = async () => {
      const status = await checkJobStatus(jobId);
      if (!status) return;

      if (status.status === "failed") {
        vulgrStatusMessage.textContent = "❌ Image generation failed.";
        return;
      }

      const images = status.result?.images || [];

      for (let i = 0; i < images.length; i++) {
        if (displayed.has(i)) continue;

        const imageData = images[i];

        // Create image element
        const img = document.createElement("img");
        img.src = imageData.base64;
        img.alt = `Generated Image ${i + 1}`;
        img.className = "vulgr-result-image";

        img.addEventListener("click", async () => {
          const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
          const blob = await (await fetch(imageData.base64)).blob();
          const file = new File([blob], `selected_image_${i + 1}.png`, {
            type: blob.type,
          });

          const dt = new DataTransfer();
          dt.items.add(file);
          fileInput.files = dt.files;

          // ✅ Manually trigger onchange event
          const event = new Event("change", { bubbles: true });
          fileInput.dispatchEvent(event);

          // ✅ Close and reset modal
          closeVulgrModal();
        });

        // Replace the corresponding dotlottie with image
        if (dotlottieElements[i]) {
          dotlottieElements[i].replaceWith(img);
        }

        // Optional: create a hidden input for file upload
        const blob = await (await fetch(imageData.base64)).blob();
        const file = new File([blob], `image_${i + 1}.png`, {
          type: blob.type,
        });

        displayed.add(i);
      }

      if (status.status !== "finished" || displayed.size < 3) {
        setTimeout(poll, 1000);
      } else {
        vulgrStatusMessage.style.display = "none";
        vulgrModalCloseButton.disabled = false;
      }
    };

    poll();
  }

  async function generateAIImage(
    prompt = "A cute cat dancing",
    model = "juggernaut"
  ) {
    const fingerprint = await getFingerprint();
    document.querySelector(".vulgr-prompt-example").style.display = "none";
    document.querySelector(".vulgr-output-example").style.display = "none";

    try {
      const res = await fetch("https://ai.vulgrco.com/generateForFrontEnd", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "kaka",
          "X-FINGERPRINT": fingerprint,
        },
        credentials: "include",
        body: JSON.stringify({ prompt, model }),
      });

      const data = await res.json();

      // Clear previous outputs
      document
        .querySelector(".vulgr-results-container")
        .querySelectorAll("img, input[type='file']")
        .forEach((el) => el.remove());

      if (!res.ok) {
        const errorMessage = data?.error || "❌ Generation failed.";
        vulgrStatusMessage.textContent = errorMessage;
        vulgrStatusMessage.style.display = "block";
        return;
      }

      if (data.job_id) {
        waitForImageJob(data.job_id);
      }
    } catch (err) {
      vulgrStatusMessage.textContent = "❌ Error during image generation.";
      vulgrStatusMessage.style.display = "block";
    }
  }

  vulgrGenerateButton.onclick = async () => {
    const prompt = vulgrPromptInput.value.trim();
    const vulgrPromptContainer = document.querySelector(
      ".vulgr-prompt-container"
    );
    if (!prompt) return vulgrPromptContainer.classList.add("error");

    // Get the selected model
    vulgrStatusMessage.textContent = "Generating Images...";
    const modelSelect = document.getElementById("vulgrModelSelection");
    const selectedModel = modelSelect.value;
    vulgrResultsContainer.style.display = "grid";
    vulgrResultsContainer.innerHTML = loadingLotties;
    vulgrPromptContainer.classList.remove("error");

    await generateAIImage(prompt, selectedModel); // Use the selected model here
  };

  function discountGuideModal() {
    const discountGuideBtn = document.getElementById("discountGuideBtn");
    const discountGuideModal = document.getElementById("discountGuideModal");
    const discountGuideCloseBtn = document.getElementById("discountGuideCloseBtn");
    const discountGuideBtnPopular = document.getElementById("discountGuideBtnPopular");
    discountGuideBtn.onclick = () => (discountGuideModal.style.display = "flex");
    discountGuideBtnPopular.onclick = () => (discountGuideModal.style.display = "flex");
    discountGuideCloseBtn.onclick = () => (discountGuideModal.style.display = "none");
  }

  // **Mutation Observer to watch for calculator form loading**
  const observer = new MutationObserver(() => {
    if (document.querySelector("#calculator")) {
      observer.disconnect();
      // document.getElementById("product_loader").classList.remove("loading");
      document.getElementById("artwork-box").classList.remove("loading--scripts");
      setupFabricSelection();
      updateCalculator();
      addToCartEvent();
      initializeSizeTabBlocks();
      refreshRemoveButtons("custom");
      refreshRemoveButtons("popular");
      discountGuideModal();

      const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
      fileInputChangeHandler(fileInput);
    }
  });

  // Initialize session
  try {
    const hasSession = await checkSession();
    if (!hasSession) await getSession();
  } catch (err) {
    document.getElementById("bg-toggle-wrapper").style.display = "none";
    console.warn("⚠️ Backend not reachable. Proceeding without session.");
  }
  observer.observe(document.body, { childList: true, subtree: true });
});
